
import utils from './src/utils/utils.js'
import localStorage from './src/utils/localStorage.js'

import languageEN from './src/language/en.js'
import languageHK from './src/language/hk.js'

export default {
    utils,
    languageEN,
    languageHK,
    localStorage
}